import { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { TacticalBoard } from "./TacticalBoard";

// ── Team Plays ─────────────────────────────────────────────────────────────
// Read-only viewer for a team's coach-drawn plays.

function TeamPlays({ userProfile, onBack }) {
  const [plays,setPlays]=useState([]),[loading,setLoading]=useState(true),[selected,setSelected]=useState(null);

  useEffect(()=>{
    if(!userProfile?.teamId){setLoading(false);return;}
    getDocs(query(collection(db,"savedPlays"),where("teamId","==",userProfile.teamId)))
      .then(snap=>setPlays(snap.docs.map(d=>({id:d.id,...d.data()}))))
      .catch(()=>setPlays([]))
      .finally(()=>setLoading(false));
  },[userProfile?.teamId]);

  if (selected) {
    return (
      <div style={{padding:"16px"}}>
        <button onClick={()=>setSelected(null)} style={{fontSize:12,color:"#231F20",background:"none",border:"none",cursor:"pointer",padding:0,fontWeight:600,marginBottom:14}}>← Back to plays</button>
        <TacticalBoard mode="view" initial={selected}/>
      </div>
    );
  }

  return (
    <div style={{padding:"16px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontSize:16,fontWeight:700,color:"#231F20"}}>📋 Team Plays</div>
        <button onClick={onBack} style={{fontSize:11,color:"#888",background:"none",border:"1px solid #ddd",borderRadius:5,padding:"4px 10px",cursor:"pointer"}}>← Back</button>
      </div>
      {loading&&<div style={{textAlign:"center",padding:"40px 0",color:"#888"}}>Loading plays...</div>}
      {!loading&&plays.length===0&&<div style={{textAlign:"center",padding:"30px",color:"#bbb",fontSize:13}}>Your coach hasn't shared any plays yet.</div>}
      {!loading&&plays.map(p=>(
        <button key={p.id} onClick={()=>setSelected(p)} style={{display:"block",width:"100%",textAlign:"left",background:"#f8f8f8",border:"1px solid #eee",borderRadius:9,padding:"12px 14px",marginBottom:8,cursor:"pointer"}}>
          <div style={{fontWeight:700,fontSize:13,color:"#231F20"}}>{p.title}</div>
          {p.description&&<div style={{fontSize:12,color:"#888",marginTop:3,lineHeight:1.4}}>{p.description}</div>}
        </button>
      ))}
    </div>
  );
}

export default TeamPlays;
